import { AlertContext } from "contexts/AlertContext"
import Modal from "components/Modal/Modal"
import { DELETE } from "api/request"
import { useContext } from "react"
import * as url from 'api/urls'

interface BookDeleteModalProps {
  onClose: () => void
  bookId: string
  onReload: () => void
}

const BookDeleteModal: React.FC<BookDeleteModalProps> = ({ bookId, onClose, onReload }) => {
  const { showAlert } = useContext(AlertContext)

  const handleSubmit = async () => {
    try {
      const response = await DELETE(url.bookDelete(bookId))
      if (response.ok) {
          window.history.back()
          onClose()
          onReload()
      } else {
        showAlert('Wystąpił błąd', 'error')
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Modal
      icon='share'
      onClose={onClose}
      title='Publikowanie'
      primaryButton={'Usuń'} primaryButtonAction={() => handleSubmit()}
      secondaryButton={'Anuluj'} secondaryButtonAction={'close'}>
      <div className="center">
      Klikając: "Usuń", usuniesz wpis na zawsze.
      </div>
    </Modal>
  )
}

export default BookDeleteModal